export default __webpack_public_path__ + "static/N0067-0d393c55d3020b54d0303bdede983063.png";